// import { useUserStore } from "@/plugins/2.pinia/modules/user";
import { $apiV1, $apiV5 } from "@plugins/axios";
import { store } from "@store";
import qs from "qs";

// const userStore = useUserStore(store);

const API = {
  user: {
    get: "/user/profile/me",
    create: "/user/profile/",
    update: "/user/profile/",
    uploadAvatar: "/user/profile/avatar/upload",
    search: "/users",
  },
  userOther: {
    get: "/user/profile/other/:userId",
    list: "/user/profile/other",
    publicList: "/user/profile/list/public/short",
  },
  candy: {
    get: "/user/candy/me",
    send: "/user/gift/send",
  },
  emoji: {
    get: "/user/emoji/list",
    buy: "/shop/emoji/buy",
  },
  twitter: {
    list: "/users",
    following: "/users/following",
    get: "/users/twitter/:twitterId",
    getByUid: "/users/twitter/:uid",
  },
  friend: {
    followFriend: "user/friends/:uid/request",
    acceptFriend: "user/friends/:uid/request",
    unfriend: "user/friends/:uid",
    deleteFriend: "user/friends/:uid/request",
    get: "user/squad/mine",
  },
  follow: {
    followers: "/user/follow/follower/list/:uid",
    followings: "/user/follow/following/list/:uid",
  },
  privateChat: {
    room: "chat/private/lobby/room/list",
    get: "chat/private/room/:friendId/chat/list",
    send: "chat/private/room/:friendId/chat",
  },
  referrers: {
    summary: "referrers/summary",
    setOnboarding: "referrers/set-onboarding",
  },
  contracts: {
    sujiBalance: "contracts/users/:userId/suji-balance",
  },
  level: {
    upgradeLevel: "user/profile/upgrade_level",
  },
};

export const getSelfProfile = async () => {
  try {
    const res = await $apiV1.get(API.user.get);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const createSelfProfile = async (data) => {
  try {
    const res = await $apiV1.post(API.user.create, data);

    // userStore.setUserInfo(res.data.user_profile);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const updateSelfProfile = async (data) => {
  try {
    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }

    const res = await $apiV1.put(API.user.update, formData, {
      headers: {
        "Content-Type": "multipart/x-www-form-urlencoded",
      },
    });

    // userStore.setUserInfo(res.data.user_profile);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const uploadSeftAvatar = async (file) => {
  try {
    const formData = new FormData();
    formData.append("profile", file);

    const res = await $apiV1.post(API.user.uploadAvatar, formData, {
      headers: {
        "Content-Type": "multipart/x-www-form-urlencoded",
      },
    });

    // userStore.setUserInfo(res.data.user_profile);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getOtherProfile = async (userId) => {
  try {
    const url = getApiPath(API.userOther.get, { userId: userId });
    const res = await $apiV1.get(url);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getSeftCandy = async () => {
  try {
    const res = await $apiV1.get(API.candy.get);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};
export const sendCandy = async (payload) => {
  try {
    const res = await $apiV1.post(API.candy.send, payload, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getSeftEmoji = async () => {
  try {
    const res = await $apiV1.get(API.emoji.get);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const buyEmoji = async (payload) => {
  try {
    const res = await $apiV1.post(API.emoji.buy, payload, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getListPublicUser = async (uids) => {
  try {
    const query = qs.stringify({ uids }, { arrayFormat: "repeat" });

    const res = await $apiV1.get(`${API.userOther.publicList}?${query}`);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response?.data || error;
  }
};

export const getUserTwitter = async (twitterId) => {
  try {
    const url = getApiPath(API.twitter.get, { twitterId: twitterId });
    const res = await $apiV5.get(url);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};
export const getUserTwitterByUid = async (uid) => {
  try {
    const url = getApiPath(API.twitter.getByUid, { uid: uid });
    const res = await $apiV1.get(url);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getUserTwitterList = async (params) => {
  try {
    const res = await $apiV1.get(API.twitter.list, { params });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getUserFollowingList = async () => {
  try {
    const res = await $apiV5.get(API.twitter.following);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getSelfEquippedItems = async () => {
  try {
    const profile = await getSelfProfile();

    return {
      profile: profile.user_profile,
      equippedItems: {
        mystic: profile.user_profile.mystic ?? null,
        mech: profile.user_profile.mech ?? null,
        orb: profile.user_profile.orb ?? null,
        equipment: profile.user_profile.equipment ?? null,
        mysticId: profile.user_profile.mystic?.id || null,
        mechId: profile.user_profile.mech?.id || null,
        orbId: profile.user_profile.orb?.id || null,
        equipmentId: profile.user_profile.equipment?.id || null,
      },
    };
  } catch (error) {
    console.error("Error getting equipped items:", error);
    throw error.response?.data || error;
  }
};

export const getSelfUid = async () => {
  try {
    const profile = await getSelfProfile();

    return profile.user_profile.uid;
  } catch (error) {
    console.error("Error getting equipped items:", error);
    throw error.response?.data || error;
  }
};

export const getListFollowers = async (payload) => {
  try {
    const url = getApiPath(API.follow.followers, { uid: payload.uid });
    const res = await $apiV1.get(url, {
      param: {
        p: payload.page,
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getListFollowings = async (payload) => {
  try {
    const url = getApiPath(API.follow.followings, { uid: payload.uid });
    const res = await $apiV1.get(url, {
      param: {
        p: payload.page,
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const sendFriendRequest = async (uid) => {
  try {
    const url = getApiPath(API.friend.followFriend, { uid: uid });
    const res = await $apiV1.post(url, {
      param: {
        friendID: uid,
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};
export const acceptFriendRequest = async (uid) => {
  try {
    const url = getApiPath(API.friend.acceptFriend, { uid: uid });
    const res = await $apiV1.put(url);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};
export const unfriend = async (uid) => {
  try {
    const url = getApiPath(API.friend.unfriend, { uid: uid });
    const res = await $apiV1.post(url, {
      param: {
        friendID: uid,
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};
export const deleteFriendRequest = async (uid) => {
  try {
    const url = getApiPath(API.friend.deleteFriend, { uid: uid });
    const res = await $apiV1.delete(url, {
      param: {
        friendID: uid,
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getFriendList = async () => {
  try {
    const res = await $apiV1.get(API.friend.get);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getPrivateChatList = async (friendId) => {
  try {
    const url = getApiPath(API.privateChat.get, { friendId: friendId });
    const res = await $apiV1.get(url);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const sendPrivateChat = async (friendId, payload) => {
  try {
    const formData = new FormData();
    formData.set("message", payload.message);

    const url = getApiPath(API.privateChat.send, { friendId: friendId });
    const res = await $apiV1.post(url, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getPrivateChatRoomList = async () => {
  try {
    const res = await $apiV1.get(API.privateChat.room);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getUsers = async (payload) => {
  try {
    const res = await $apiV5.get(API.user.search, {
      params: {
        ...payload,
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getReferrersSummary = async (payload) => {
  try {
    const res = await $apiV5.get(API.referrers.summary, {
      params: {
        ...payload,
      },
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const setReferrerOnboarding = async (referrer) => {
  try {
    const res = await $apiV5.post(API.referrers.setOnboarding, {
      referrer,
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const getSujiBalance = async (userId) => {
  try {
    const url = getApiPath(API.contracts.sujiBalance, { userId: userId });
    const res = await $apiV5.get(url);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

export const upgradeLevel = async () => {
  try {
    const res = await $apiV1.post(API.level.upgradeLevel);

    return res.data;
  } catch (error) {
    console.error(error);
    throw error.response.data || error;
  }
};

